import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';

import {AnimationContents} from '../../../../AnimationContents';

import {GameModel, GameStateEnum} from '../../../Models/GameModel';

import {GameLogic} from '../../../Logic/GameLogic';

import { FriendsListListController } from './FriendsListListController';
import { ButtonController, IButtonControllerOptions } from '../../../Common/ButtonController';
import { ISliderControllerOptions, SliderController } from '../../../Controllers/UI/SliderController';

export interface IFriendsListControllerOptions {
    onExit(status: boolean):void;
}


export class FriendsListModalController extends AnimationBaseController {
    $model: GameModel;

    private _slider: SliderController;
    private _list: FriendsListListController;
    private _inputElement: HTMLInputElement;
    private _inputSprite: PIXI.Sprite;
    private _searchTextField: PIXI.Text;
    private _inputCursorVisible: boolean = true;
    private _inputCursorTime: number = 0;
    private _currentText: string

    public constructor(
        @Inject private _options: IFriendsListControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('FriendsListModalController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.FRIENDS_LIST_MODAL_JSON,
            libraryName: 'Friend_list_window',
            childControllers: {
                btn_exit: {
                    instanceName: "btn_exit", // TODO adjust fla
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                            this._options.onExit(status)
                        },
                    },
                },
                btn_invite_all: {
                    instanceName: "btn_invite_all", // TODO adjust fla
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                            console.log('Click on invite all')
                            // TODO: add "invite all" method here
                        },
                    },
                },
                abstractSlider: {
                    instanceName: 'friend_list__slider',
                    controller: SliderController,
                    options: <ISliderControllerOptions>{
                        trackLength: 430,
                        onScroll: (value) => {
                            (this.$childControllers.get('friend_list__list') as FriendsListListController).setPosition(value)
                        }
                    }
                }
            },
        };
    }

    protected onInitialize() {
        this.addChildController({
            controller: FriendsListListController,
            options: {

                }
            }, 'friend_list__list');

        this._slider = this.$childControllers.get('abstractSlider')

        this._list = this.$childControllers.get('friend_list__list') as FriendsListListController;
        this.handleMouseWheel = this.handleMouseWheel.bind(this);
        window.addEventListener('wheel', this.handleMouseWheel, false)
        this._list.friends = this._gameLogic.getFriendList()
        this._list.display.interactive = true;
        let data = null;
        let prevY = null;
        let dragging = false;
        this._list.display
            .on('pointerdown', (event) => {
                data = event.data
                prevY = event.data.global.y;
                dragging = true
            })
            .on('pointerup', () => {
                dragging = false;
                data = null;
                prevY = null;
            })
            .on('mouseupoutside', () => {
                dragging = false;
                data = null;
                prevY = null;
            })
            .on('pointermove', () => {
                if (dragging) {
                    this._slider.scroll(-data.global.y + prevY);
                    prevY = data.global.y;
                }
            })

        this._inputSprite = this.getDisplayObjectByQuery('search')[0] as PIXI.Sprite
        this._inputSprite.interactive = true;
        this._inputSprite.buttonMode = true;
        this.createInputElement = this.createInputElement.bind(this);
        this._inputSprite.on('click', this.createInputElement);
        this._searchTextField = this.getDisplayObjectByQuery('search__textfield')[0] as PIXI.Text;
    }

    protected onUpdate(frameRate: number) {
        if (this._slider)
            this.setPosByQuery('slider.slider_btn', -4, this._slider.button.x - 250);

        if (this._inputElement) {
            this._inputCursorTime += frameRate;
            if (this._inputCursorTime >= 0.8) {
                this._inputCursorTime = 0;
                this._inputCursorVisible = !this._inputCursorVisible;
                this._searchTextField.text = `${this._currentText}${this._inputCursorVisible ? '|' : ''}`;
            }
        }
    }

    protected onResize(width: number, height: number, scale: number) {

        this.scaleX = Math.min(width / scale / this.width, height / scale / this.height);
        this.scaleY = Math.min(width / scale / this.width, height / scale / this.height);

        this._slider.display.x = 618;
        this._slider.display.y = -50;
        this._slider.display.rotation = Math.PI / 2;
        this._slider.alpha = 0;

        this.$childControllers.get('friend_list__list').display.x = -616;
        this.$childControllers.get('friend_list__list').display.y = -100;

        if (this._inputElement) {
            this._inputElement.style.left = `${this._searchTextField.getGlobalPosition().x}px`;
            this._inputElement.style.top = `${this._searchTextField.getGlobalPosition().y}px`;
            this._inputElement.style.width = `${this._searchTextField.width}`;
            this._inputElement.style.height = `${this._searchTextField.height}`;
        }
    }

    protected onDestroy() {
        document.removeEventListener('wheel', this.handleMouseWheel)
        super.onDestroy();
    }

    private handleMouseWheel(e) {
        this._slider.scroll(e.deltaY);
    }

    private createInputElement() {
        if (this._inputElement) return;
        this._currentText = this._searchTextField.text;
        this._inputCursorVisible = false;
        this._inputCursorTime = 0;
        this._inputElement = document.createElement('input')
        this._inputElement.type = 'text';
        this._inputElement.style.position = 'absolute';
        this._inputElement.style.left = `0`;
        this._inputElement.style.zIndex = '-1000';
        this._inputElement.style.top = `0`;
        this._inputElement.style.display = 'block';
        this._inputElement.style.border = '0';
        // this._inputElement.style.opacity = '0';
        document.body.appendChild(this._inputElement);
        this._inputElement.focus()
        this._inputElement.value = this._currentText;
        this._inputElement.addEventListener('input', (e) => {
            this._currentText = this._inputElement.value;
            this._searchTextField.text = `${this._currentText}${this._inputCursorVisible ? '|' : ''}`;
        });
        this._inputElement.addEventListener('keydown', (e) => {
            console.log('input', e);
            switch (e.key) {
                case 'ArrowLeft':
                case 'ArrowRight':
                    e.preventDefault();
                    break;
                case 'Enter':
                    this._inputElement.blur();
                    // TODO add search code;
            }

        })
        this._inputElement.onblur = () => {
            document.body.removeChild(this._inputElement);
            this._searchTextField.text = this._currentText;
            this._inputElement = null;
        }
    }
}
